<i18n>
{
  "en": {
    "refreshTokenSuccess": "Refresh token success",
    "refreshTokenError": "Refresh token error",
    "cacheLoadingError": "Error loading the menu data"
  },
  "es": {
    "refreshTokenSuccess": "Éxito refrescando token",
    "refreshTokenError": "Error refrescando token:",
    "cacheLoadingError": "Error cargando los datos del menu"
  }
}
</i18n>

<template>
  <fragment>
    <menu-render v-if="cache"
                 :structureData="cache.menu_structure"
                 :pricesData="cache.prices_cache"
                 :userDefinedData="cache.editable_aspects_cache"
                 :zoneOfConsume="cache.selectedZone"
                 :initialRecommendationStructure="initialRecommendation"
                 :bannerShopStructure="bannerShopStructure"
    />
    <dynameat-spinner v-if="isLoading"></dynameat-spinner>
  </fragment>
</template>

<script>

import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import MenuRender from '@menurender/MenuRender';
import { menuRenderModule } from '@menurender/module';
import { createErrorNotification } from '@ulibs/unnotificationsqueue';
import { HttpController, SessionController } from '@core/helpers';
import { REFRESH_TOKEN_FREQUENCY } from '@dynameat/constants';
import * as api from '@dynameat/api';
import DynameatSpinner from '@dynameat/components/DynameatSpinner.vue';

@Component
@Components({ MenuRender, DynameatSpinner })
@MapGetters(['isLoading'])
@MapActions(['addNotification', 'setLoading'])
export default class MenuRenderView extends Vue {
  cache = null;

  initialRecommendation = {};

  bannerShopStructure = {}

  async created() {
    // Setup session
    HttpController.setupHttpClient(SessionController.token);
    await this.refreshSession();
    setInterval(this.refreshSession, REFRESH_TOKEN_FREQUENCY);
    this.setUpStyles();
  }

  setUpStyles() {
    const element = document.getElementById('app');
    element.style.height = '100%';
    document.documentElement.style['overflow-y'] = 'hidden';
  }

  async refreshSession() {
    try {
      if (SessionController.needRefreshSession() && !SessionController.token) {
        await this.$store.dispatch('logout');
        await this.$router.push('/login');
      } else if (SessionController.needRefreshSession()) {
        const oldToken = SessionController.token.replace('JWT ', '');
        const newTokenRaw = await api.refreshTokenRequest(oldToken);
        const newToken = `JWT ${newTokenRaw}`;
        SessionController.token = newToken;
        SessionController.timestamp = new Date().getTime();
        HttpController.setupHttpClient(newToken);
      }
    } catch (err) {
      this.setLoading(1);
      this.addNotification(createErrorNotification(this.$t('refreshTokenError'), {
        onRemove: (async () => {
          this.setLoading(-1);
          await this.$store.dispatch('logout');
          await this.$router.push('/login');
        })
      }, 5000));
    }
  }

  async mounted() {
    if (!this.$store.hasModule('menuRenderPreview')) {
      this.$store.registerModule('menuRenderPreview', menuRenderModule);
    }
    await this.loadMenuRenderData();
  }

  async loadMenuRenderData() {
    const {
      menuGuid, zoneGuid, serviceGuid, year, month, day
    } = this.$route.params;
    try {
      await this.setLoading(1);
      this.cache = (await api.menuPreviewCacheRequest(menuGuid, zoneGuid, serviceGuid, year, month, day)).data;
      this.cache.selectedZone = zoneGuid;
      this.cache.prices_cache = { [this.cache.selectedZone]: this.cache.prices_cache };
      this.initialRecommendation = (await api.menuPreviewInitialRecommendationRequest(menuGuid)).data;
      this.bannerShopStructure = (await api.menuPreviewBannerShopStructureRequest(menuGuid)).data;
    } catch (e) {
      this.addNotification(createErrorNotification('cacheLoadingError', {}, 3000));
    } finally {
      await this.setLoading(-1);
    }
  }
}
</script>
